import { useQuery } from '@cbgms/base/http/use-query'
import { EmptyUUID } from '@cbgms/base/utils/uuid'
import { useDispatch } from 'react-redux'
import { getVehicle } from '../state/actions'

export const SHOP_VEHICLE = 'SHOP_VEHICLE'

export const useGetVehicle = (vehicleUUID: string, keys: string[] = [SHOP_VEHICLE]) => {
  const dispatch = useDispatch()
  return useQuery([...keys, vehicleUUID], async () => {
    if (!vehicleUUID || vehicleUUID === EmptyUUID) {
      return null
    }
    const result = await dispatch(getVehicle(vehicleUUID))
    return result.Data
  })
}
